var map = {
	"./bigcat5.png": "482a",
	"./bigcat6_down_arrow.png": "6566",
	"./bigcat6_up_arrow.png": "8f62",
	"./bigcat6_yingwen.png": "38e8",
	"./bigcat6_zhongwen.png": "2ad2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa18";